<template>
  <b-col class="col-12 position-relative">
    <b-link v-if="id" class="text-body" :title="$t('colonies.delete')" @click.prevent="clickDelete">
      <span v-if="!deleteProgress" class="icon-delete_filled" aria-hidden="true"></span>
      <div v-if="deleteProgress" class="text-body">
        <b-spinner></b-spinner>
      </div>
    </b-link>

    <b-modal :id="'confirmColony_'+ id" centered hide-header-close @ok="doDelete" class="delete-container">
      <template slot="modal-title">
      {{ $t('colonies.confirm_delete.title') }}
      </template>
      <div class="dialog-text" >
        {{ $t('colonies.confirm_delete.text') }}
      </div>
      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button size="lg" class="ml-auto" @click="cancel()">
          {{ $t('colonies.confirm_delete.no') }}
        </b-button>
        <b-button size="lg" class="mr-auto" @click="ok()">
          {{ $t('colonies.confirm_delete.yes') }}
        </b-button>
      </template>
    </b-modal>
<!--    <b-modal :id="'confirmUniteColony_'+ id" centered hide-header-close  class="delete-container">-->
<!--      <template slot="modal-title">-->
<!--        {{ $t('colonies.confirm_delete.title') }}-->
<!--      </template>-->
<!--      <div class="dialog-text">-->
<!--        {{ $t('unite_colonies_or_remove_queen.text') }}-->
<!--      </div>-->
<!--      <template slot="modal-footer" slot-scope="{ cancel }">-->
<!--        <b-button size="lg" class="ml-auto" @click="cancel()">-->
<!--          {{ $t('colonies.confirm_delete.cancel') }}-->
<!--        </b-button>-->
<!--        <b-button size="lg" class="mr-auto" @click="deleteQueen()">-->
<!--          {{ $t('unite_colonies_or_remove_queen.remove_queen') }}-->
<!--        </b-button>-->
<!--        <b-button size="lg" class="mr-auto" @click="uniteColony()">-->
<!--          {{ $t('unite_colonies_or_remove_queen.unite_colonies') }}-->
<!--        </b-button>-->
<!--      </template>-->
<!--    </b-modal>-->
    <b-modal :id="'confirmUniteColony_'+ id" centered hide-header-close  class="delete-container">
      <template slot="modal-title">
        {{ $t('colonies.confirm_delete.title') }}
      </template>
      <div class="dialog-text" v-if="!deleteQueenProgress && !isQueenDeleted">
        {{ $t('unite_colonies_or_remove_queen.text') }}
      </div>
      <div class="dialog-text" v-else-if="deleteQueenProgress && !isQueenDeleted">
        <b-row>
          <b-col class="col-12 mb-3">
            <div class="d-flex justify-content-around flex-row mb-3"><b-spinner></b-spinner></div>
          </b-col>
        </b-row>
      </div>
      <div class="dialog-text" v-else>
        {{ $t('queen.modal.confirm_delete_text') }}
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="lg" class="ml-auto" @click="cancel()" v-if="!deleteQueenProgress && !isQueenDeleted">
          {{ $t('colonies.confirm_delete.cancel') }}
        </b-button>
        <b-button size="lg" class="mr-auto" @click="deleteQueen()" v-if="!deleteQueenProgress && !isQueenDeleted">
          {{ $t('unite_colonies_or_remove_queen.remove_queen') }}
        </b-button>
        <b-button size="lg" class="mt-3" @click="onDeleteConfirm()" v-if="isQueenDeleted">
          {{ $t('queen.modal.ok') }}
        </b-button>
      </template>
<!--      <template slot="modal-footer" v-else-if="isQueenDeleted">-->
<!--      </template>-->
    </b-modal>
    <b-modal :id="'offLineModalColony_'+ id" centered hide-header-close @ok="hideModal" class="delete-container">
      <template slot="modal-title">
        {{ $t('offLineModal.title') }}
      </template>
      {{ $t('offLineModal.text') }}
      <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
        <b-button size="lg" class="mt-3" @click="ok()">
          {{ $t('offLineModal.ok') }}
        </b-button>
      </template>
    </b-modal>
  </b-col>
</template>

<script>
export default {
  name: 'ColonyDelete',
  props: ['id', 'queen', 'apiary', 'formList'],
  data () {
    return {
      deleteProgress: false,
      deleteQueenProgress: false,
      isColonyDeleted: false,
      isQueenDeleted: false
    }
  },
  methods: {
    async clickDelete () {
      if (navigator.onLine) {
        if (this.queen) {
          this.deleteProgress = true
          const queen = await this.$api.queens.getOne(this.queen)
          if (queen) {
            this.deleteProgress = false
            this.showUniteModal()
          } else {
            this.deleteProgress = false
            // this.showModal()
            this.$router.push('/unite-colonies-or-remove-queen3/' + this.id)
          }
        } else {
          // this.showModal()
          this.$router.push('/unite-colonies-or-remove-queen3/' + this.id)
        }
      } else {
        this.showOffLineModal()
      }
    },
    onDeleteConfirm () {
      this.loaded = true
      this.$router.push('/unite-colonies-or-remove-queen3/' + this.id)
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalColony_' + this.id)
    },
    hideModal () {
      this.$bvModal.hide('offLineModalColony_' + this.id)
    },
    showModal () {
      this.$bvModal.show('confirmColony_' + this.id)
    },
    showUniteModal () {
      this.$bvModal.show('confirmUniteColony_' + this.id)
    },
    async deleteQueen () {
      // this.$router.push('/unite-colonies-or-remove-queen2/' + this.queen + '/' + this.id)
      if (navigator.onLine) {
        this.deleteQueenProgress = true
        const token = await this.$api.user.getToken()
        const result = this.$api.queens.deleteItem({ id: this.queen, token })
        this.deleteQueenProgress = false
        this.isQueenDeleted = true
        return result
      } else {
        this.showOffLineModal()
      }
    },
    uniteColony () {
      this.$router.push('/unite-colonies/' + this.id)
    },
    async doDelete () {
      if (navigator.onLine) {
        this.loaded = true
        this.$router.push('/unite-colonies-or-remove-queen3/' + this.id)
        // let result
        // try {
        //   this.deleteProgress = true
        //   this.$emit('confirmDelete', this.id)
        //   const token = await this.$api.user.getToken()
        //   result = await this.$api.colonies.deleteItem({ id: this.id, token })
        //   this.$emit('confirmDelete', null)
        //   this.deleteProgress = false
        //   this.isColonyDeleted = true
        // } catch (e) {
        //   if (e.response && e.response.status === 403) {
        //     this.$emit('confirmDelete', null)
        //     this.$router.replace('/login')
        //   }
        //   return false
        // }
        // if (!this.formList) {
        //   this.$router.replace('/apiary/' + this.apiary)
        // }
        // return result
      } else {
        this.showOffLineModal()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  h2 {
    font-size: 1.5rem;
    font-family: $font-family-sans-serif;
  }
  .delete-container {
    font-family: $font-family-sans-serif;
  }
  .action-row {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.5rem;
    line-height: 1rem;

    > * {
      display: inline-block;
      padding: 1rem 1.25rem;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .card {
    background-color: $secondary-light;
  }
  .card-body {
    padding: 1.25rem;
  }
</style>
